export const ROUTES = {
  SIGN_IN: '/sign-in',
  SIGN_IN_LINK: '/sign-in/link',
  WELCOME: '/welcome',
  GET_STARTED: '/get-started',
  OVERVIEW: '/',
  BILLING: '/billing',
  PLANS: '/billing/plans',
  CONNECTIONS: '/connections',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

export const OAUTH_PROVIDERS = ['google', 'github'] as const;
export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];

export type OAuthMode = 'popup' | 'redirect';

export const buildOAuthStartPath = (provider: OAuthProvider, mode: OAuthMode): string =>
  `/auth/oauth/${provider}/start?mode=${mode}`;

/** A `?redirect=` value is honoured only when it is a same-origin path. */
export function safeRedirect(value: string | null | undefined): AppRoute | string | null {
  if (!value?.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return null;
  }
  return value;
}
